import DOMPurify from 'isomorphic-dompurify';

// Trusted Types policy for TipTap editor and DOMPurify
if (typeof window !== 'undefined' && window.trustedTypes) {
  try {
    // Create policy for TipTap and general usage
    window.trustedTypes.createPolicy('default', {
      createHTML: (string) => {
        // Use DOMPurify to sanitize HTML
        return DOMPurify.sanitize(string, {
          RETURN_TRUSTED_TYPE: true,
          ADD_TAGS: ['iframe'],
          ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling'],
        }) as unknown as string;
      },
      createScript: (string) => string,
      createScriptURL: (string) => string,
    });
  } catch (e) {
    // Policy already exists, ignore
    console.warn('Trusted Types policy already exists:', e);
  }

  // Configure DOMPurify to work with Trusted Types
  if (DOMPurify.isSupported) {
    DOMPurify.setConfig({
      RETURN_TRUSTED_TYPE: true,
    });
  }
}

export {};
